import React, { createContext, PropsWithChildren, useContext, useEffect, useState } from 'react'
import client from 'api/auth'

declare let RDS_API_SVC: string

export interface DriverInfo {
  name: string
  type: string
  email: string | null
  phone: string | null
  tracking_link: string | null
}

const DriverCtx = createContext<DriverInfo | null>(null)

function loadDriver(orderId: string): Promise<DriverInfo | null> {
  const token = client.getAuthResponse() ? client.getAuthResponse().access_token : null
  return fetch(`${RDS_API_SVC}/v5/driver/order/${orderId}`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
      Authorisation: `Bearer ${token}`,
    },
  })
    .then((res: Response) => (res.ok ? res.json() : null))
    .catch(() => null)
}

export function DriverSvc(props: PropsWithChildren<{ orderId: string }>): JSX.Element {
  const [driverData, setDriverData] = useState<DriverInfo | null>(null)

  useEffect(() => {
    loadDriver(props.orderId).then(setDriverData)
  }, [props.orderId])

  return <DriverCtx.Provider value={driverData}>{props.children}</DriverCtx.Provider>
}

export function useDriverAPI(): DriverInfo | null {
  return useContext(DriverCtx)
}